// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"44":"ef01080a","191":"80fedafe","402":"d772c988","453":"af205ec6","457":"8b00e78f","780":"ec71b830","788":"5eb733ec","849":"637c2fd1","950":"d243ccfc"}[chunkId] + ".chunk.js";
};